// config/AppVersion.js
export const appVersion = 'v1.0.29'; // Versão do aplicativo